import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "defaultIndex", "index", "isManual", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext, useRef, useState } from 'react';
import cx from 'classnames';
import { useId } from '../../hooks';
import { prefix } from '../../tools/settings';
import { StyledVerticalTabs } from './VerticalTabs.styles';
import TabPanels from './components/TabPanels';
import TabPanel from './components/TabPanel';
import TabList from './components/TabList';
import Tab from './components/Tab';
import { jsx as _jsx } from "react/jsx-runtime";
export var VerticalTabsContext = createContext();
var VerticalTabs = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      defaultIndex = _ref.defaultIndex,
      controlledIndex = _ref.index,
      isManual = _ref.isManual,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useRef = useRef(controlledIndex != null),
      isControlled = _useRef.current;

  var selectedPanelRef = useRef();

  var getInitialIndex = function getInitialIndex() {
    if (!isManual) {
      return defaultIndex || 0;
    } else {
      return controlledIndex || defaultIndex || 0;
    }
  };

  var getActualIdx = function getActualIdx() {
    if (isManual) {
      return selectedIndex;
    } else {
      return isControlled ? controlledIndex : selectedIndex;
    }
  };

  var _useState = useState(getInitialIndex),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  var _useState3 = useState(controlledIndex || defaultIndex || 0),
      _useState4 = _slicedToArray(_useState3, 2),
      manualIndex = _useState4[0],
      setManualIndex = _useState4[1];

  var actualIdx = getActualIdx();
  var manualIdx = isControlled ? controlledIndex : manualIndex;

  var onChangeTab = function onChangeTab(index) {
    if (!isControlled) {
      setSelectedIndex(index);
    }

    if (isControlled && isManual) {
      setSelectedIndex(index);
    }

    if (!isManual) {
      onChange && onChange(index);
    }
  };

  var onManualTabChange = function onManualTabChange(index) {
    if (!isControlled) {
      setManualIndex(index);
    }

    if (isManual) {
      onChange && onChange(index);
    }
  };

  var onFocusPanel = function onFocusPanel() {
    if (selectedPanelRef.current) {
      selectedPanelRef.current.focus();
    }
  };

  var id = useId();
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-verticaltabs"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(VerticalTabsContext.Provider, {
    value: {
      id: id,
      index: actualIdx,
      isManual: isManual,
      manualIndex: manualIdx,
      onChangeTab: onChangeTab,
      onFocusPanel: onFocusPanel,
      onManualTabChange: onManualTabChange,
      selectedPanelRef: selectedPanelRef
    },
    children: _jsx(StyledVerticalTabs, _objectSpread(_objectSpread({
      ref: ref,
      id: id,
      className: className
    }, rest), {}, {
      children: children
    }))
  });
});
VerticalTabs.Tab = Tab;
VerticalTabs.List = TabList;
VerticalTabs.Panels = TabPanels;
VerticalTabs.Panel = TabPanel;
export default VerticalTabs;